export default __webpack_public_path__ + "static/media/serviceused.5ad6ce5d.png";